module.exports = __webpack_public_path__ + "static/media/date.c1a1c781.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/date.png
// module id = 45
// module chunks = 0